import { ReactEnvironments } from "../pages/common/constants";
import { loadExternalScript } from "./scriptLoader";

const NEW_RELIC_SCRIPT_ID = "new-relic-script";

export const initializeNewRelic = (environment: string): void => {
  if (environment === ReactEnvironments.Local) {
    return;
  }

  const isProduction = environment === ReactEnvironments.Production;

  const scriptSrc = isProduction
    ? "/newrelic-prod.js"
    : "/newrelic-non-prod.js";

  loadExternalScript(scriptSrc, NEW_RELIC_SCRIPT_ID);
};
